import { Link } from 'wouter';
import { formatDate, formatHours } from '@/lib/utils';

export interface CertEntry {
  moduleId: string;
  moduleTitle: string;
  hours: number;
  certId: string;
  completedAt: string;
}

interface MyCertificatesProps {
  certs: CertEntry[];
}

export function MyCertificates({ certs }: MyCertificatesProps): React.ReactElement | null {
  if (certs.length === 0) return null;

  return (
    <section aria-label="My certificates">
      <div className="flex items-center gap-3 mb-6">
        <span className="material-symbols-outlined text-[var(--stitch-surface-tint)] is-filled">workspace_premium</span>
        <h2 className="stitch-font-headline text-[24px] text-[var(--stitch-primary)] tracking-tight">
          My Certificates
        </h2>
      </div>

      <div className="space-y-4">
        {certs.map(cert => (
          <div
            key={cert.certId}
            className="bg-[var(--stitch-surface-container-low)]/60 border border-[var(--stitch-surface-container-high)] p-6 rounded-xl flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:bg-[var(--stitch-surface-container-low)] transition-colors"
          >
            <div className="min-w-0">
              <h4 className="stitch-font-headline text-[17px] text-[var(--stitch-primary)] mb-1 truncate">
                {cert.moduleTitle}
              </h4>
              <p className="stitch-font-body text-sm text-[var(--stitch-on-surface-variant)] opacity-80">
                {formatDate(cert.completedAt.split('T')[0] ?? cert.completedAt)} · {formatHours(cert.hours)} hr CPD
              </p>
            </div>
            <Link
              href={`/cert/${cert.moduleId}`}
              className="shrink-0 text-[var(--stitch-primary)] stitch-font-label text-[12px] flex items-center gap-2 group uppercase tracking-wider"
            >
              <span className="material-symbols-outlined text-xl group-hover:translate-y-0.5 transition-transform">download</span>
              View &amp; Download
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
